import { Button, CircularProgress } from "@mui/material"
import { observer } from "mobx-react-lite"
import React from "react"
import { AlertModal, DisplayValue } from "../../../../..";
import { Enquiry } from "../../../../../models/Enquiry";
import { store } from "../../../../../stores/Store";
import EnquiryUpdateSectionForm from "../../../../form/enquiry/EnquiryUpdateSectionForm";
import Help from "../../../../../misc/Help";
import { Theme } from "../../../../../misc/Theme";


interface EnquirySectionProps {
    enquiry: Enquiry;
    editable?: boolean;
    showCertainty?: boolean;
    maxHeight?: string;
}


export default observer(function EnquiryStatusSection ({enquiry, editable = true, showCertainty = true, maxHeight = "none"}: EnquirySectionProps) {

    var {sessionState} = store.AppStore
    var statusesSection = enquiry?.childrenObjects?.find(c => c.name === "STATUSES")

    const UpdateForm = () => {
        if (statusesSection) {
            AlertModal({title: "Statuses to Evaluate", body: <EnquiryUpdateSectionForm enquiryUid={enquiry.uid} section={statusesSection} />})
        }
    }

    var statuses = enquiry.childrenObjects.find(c => c.name === "STATUSES")?.childrenObjects
    var sections = []
     
    // Restructure to list of sections
    statuses.filter(s => s.selected).forEach(status => {
        
        var existingSection = sections.find(s => s.type === status.type)
        
        if (existingSection) {
            existingSection.rows.push(status)
        } else {
            sections.push({
                label: status.type,
                type: status.type,
                rows: [status]
            })
        }
    })

    return (
        <div>
            <div className="section-header">
                <div className="header-content">
                    <h4>Statuses evaluated</h4>
            
                    {editable && !sessionState ? <Button className="btn btn-sm" onClick={() => UpdateForm()}>Edit</Button> : null}
                </div>
            </div>

            <div className="detail-section" style={{overflowY: "auto", maxHeight: maxHeight}}>            
                {sections.map((section, i) => (
                    <React.Fragment key={i}>
                        {sections.length > 1 ? (
                            <div className="section-header section-subheader">
                                <h5>{DisplayValue("nationality_type", section.label)}</h5>
                            </div>
                        ) : null}
                        
                        <div className="section-table">
                            {section.rows.filter(s => s.selected === true).map((status, i) => <Status key={i} status={status} enquiryStatus={enquiry.status} showCertainty={showCertainty} />)}
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </div>
    )
})


export function Status ({status, enquiryStatus, showCertainty}) {

    var value = status.value
    var valueIsValid = true
    var valueDesciption = null

    switch (enquiryStatus) {
        case "INTERIM":
        case "DEFINITIVE":
        case "REPORT_DATA_REQUIRED":
            break
        case "FINAL":
            value = status.lastInterimValue
            break
        case "RERUN_REQUIRED":
            valueIsValid = false
            value = status.lastDefinitiveValue
            valueDesciption = "This full outcome had previously been reached but was then made invalid by relevant data being changed"
            break
        default:
            value = "Unknown"
            valueDesciption = "An outcome has not yet been reached"
    }

    var outcome = value ? DisplayValue("yes_no_outcome", value) : "Unknown"
    var color = store.EnquiryStore.outcomeColor(value)
    
    return (
        <div className="section-row attribute-row">
            <div className="section-cell">{status.label}</div>

            <div className="section-cell" style={{width: "95px"}}>
                <div className="font-md" style={{color: color, fontWeight: 600, alignItems: "center", gap: "4px", textDecoration: !valueIsValid ? "line-through" : ""}}>
                    {valueDesciption ? <Help content={outcome}>{valueDesciption}</Help> : outcome}
                </div>
            </div>
            
            {showCertainty ? (
                <div className="section-cell" style={{maxWidth: "70px", width: "100%"}}>
                    <span style={{ margin: "0 10px 0 auto"}}>
                        <CertaintyLabel certainty={status.certainty} />
                    </span>
                </div>
            ) : null}
        </div>
    )
}


const CertaintyLabel = ({certainty}) => {
        
    if (store.AppStore.sessionState?.includes("Running")) {
        return (
            <Help content={<CircularProgress style={{width: "10px", height: "10px"}} />}>
                This nationality is currently being evaluated
            </Help>
        )
    } 

    if (certainty === "D") {
        return (
            <Help content={<span style={{color: Theme.palette.warning.dark}}>{DisplayValue("certainty", certainty)}</span>}>
                This outcome may require further conditions to be met, see the full explaination under 'Outcome details'.
            </Help>
        )
    }
    
    return DisplayValue("certainty", certainty)
}